/* eslint-disable jsx-a11y/mouse-events-have-key-events */
/* eslint-disable jsx-a11y/media-has-caption */
import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import DateFormatter from 'common/utils/DateFormatter';
import NoneAccess from "../non-access";
import PreviewVideo from 'sites/views/media-modules/preview-video';
import { PreviewVideoFullScreen } from 'sites/views/media-modules/preview-video/modules';
import Icon from 'common/components/elements/icons';

const VideoCardContent = ({
   posterSrc,
   previewSrc,
   showComingSoon,
   date,
   blurhash,
   onClickJoin,
   streamStatus,
   streamPrice,
   onClickUnlock,
   paymentButtonLoading,
   isCustomPreview,
   children,
   voiceIconRightPosition,
   streamState,
   isLockedForAllMemberships,
   siteInfo,
   isHomepage,
   isPlayPreview,
   videoId,
   endsIn,
   isLockedForSFW,
   cannotPreviewForSfw,
   isAutoPlay,
   screenWidth,
   setIsAutoPlay,
}) => {
   const [openFullscreen, setOpenFullScreen] = useState(false);
   const videoRef = useRef();

   const canPlayPreview = () => {

      if(screenWidth > 1024) {
         return isAutoPlay;
      }
      return isPlayPreview
   }

   let leftDate = null;
   if(showComingSoon){
      leftDate = DateFormatter.getDateLeft(date, false, 'In a few minutes');
   }

   let calculateTimeLeft = () => DateFormatter.calculateTimeLeft(endsIn)
   const [timeLeft, setTimeLeft] = useState(endsIn ? calculateTimeLeft() : null);
   const [hideElement, setHideElement] = useState(false)

   useEffect(() => {
      let timer
      if(timeLeft !== null) {
         timer = setInterval(() => {
            setTimeLeft(calculateTimeLeft());
         }, 1000);
      }

      return () => clearInterval(timer);
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [timeLeft]);

   return (
      <>
         <div
            ref={ videoRef }
            onMouseOver={ () => {
               if(openFullscreen) return;
               setHideElement(true)
            } }
            onMouseOut={ () => {
               setHideElement(false)
            } }
            role='presentation'
            className='absolute w-full h-full flex flex-col justify-between inset-0 z-0'
         >
            <div className='w-full h-full relative flex'>
               {
                  !!blurhash && (
                     <NoneAccess
                        type='video'
                        blurhash={ blurhash }
                        state={ streamStatus }
                        unlockPrice={ streamPrice }
                        onClickButton={ (status) => {
                           if('unlock_or_join' === status || 'unlock' === status) {
                              onClickUnlock()
                           } else {
                              onClickJoin()
                           }
                        } }
                        showComingSoon={ showComingSoon && !hideElement }
                        paymentButtonLoading={ paymentButtonLoading }
                        streamState={ streamState }
                        isLockedForAllMemberships={ isLockedForAllMemberships }
                     />
                  )
               }
               {
                  openFullscreen && (
                     <PreviewVideoFullScreen
                        openFullscreen={ true }
                        setOpenFullScreen={ (bool) => {
                           setOpenFullScreen(bool)
                           setIsAutoPlay(false)
                        } }
                        showVolumeButton={ isCustomPreview }
                        autoPlay={ true }
                        previewSrc={ previewSrc }
                     />
                  )
               }
               {

                  !!previewSrc && canPlayPreview() && (
                     <PreviewVideo
                        showFullScreenButton
                        previewSrc={ previewSrc }
                        showVolumeButton={ isCustomPreview }
                        poster={ posterSrc }
                        voiceIconRightPosition={ voiceIconRightPosition }
                        videoId={ videoId }
                        isContentCard
                        thumbnailIsLockedForSFW={ isLockedForSFW }
                        isLockedForSFW={ cannotPreviewForSfw }
                        setOpenFullScreen={ _ => {
                           setOpenFullScreen(true);
                           if(!!previewSrc && screenWidth > 1024){
                              setIsAutoPlay(false);
                           }
                           setHideElement(false);
                        } }
                        openFullscreen={ openFullscreen }
                     />
                  )
               }
               {
                  !canPlayPreview() && posterSrc && (
                     <>
                        <div
                           className='absolute w-full h-full bg-no-repeat bg-cover inset-0'
                           style={ {
                              filter: `blur(8px)`,
                              backgroundImage: `url(${ posterSrc })`,
                           } }
                        />
                        <div
                           className='absolute w-full h-full bg-no-repeat bg-contain bg-center z-20'
                           style={ {
                              backgroundImage: `url(${ posterSrc })`,
                              filter: isLockedForSFW ? 'blur(32px)' : '',
                           } }
                        />
                     </>
                  )
               }
               {
                  !!showComingSoon &&
                  <div
                     style={ {
                        visibility: hideElement ? 'hidden' : '',
                     } }
                     className='absolute w-full full text-major-dark bg-no-repeat bg-cover inset-0 flex flex-col items-center justify-center bg-major-60 z-30 '>
                     <div className='flex flex-col justify-between z-20'>
                        <span className='font-bold coming-soon-text text-center'>Coming soon</span>
                        <span className='leading-tight mt-2 text-center'>{leftDate}</span>
                     </div>
                  </div>
               }
               {
                  !!timeLeft && !showComingSoon &&
                  <div
                     role='presentation'
                     className={ `non-published-bg bg-major-60 dark:bg-grey-hover-dark-60  rounded-lg absolute top-0 z-30 left-0 w-full h-full flex flex-col items-center justify-center gap-2 hover:opacity-0` }
                  >
                     <Icon
                        name='clock'
                        color='major-dark'
                        size='2xl'
                     />
                     <span className=' text-major-dark text-xl leading-4 font-medium select-none'>Ends in</span>
                     <span className=' text-major-dark block select-none'>{timeLeft}</span>
                  </div>
               }
            </div>
         </div>
         {children}
      </>
   );
};

VideoCardContent.propTypes = {
   posterSrc: PropTypes.string,
   previewSrc: PropTypes.any,
   showComingSoon: PropTypes.bool,
   date: PropTypes.string,
   blurhash: PropTypes.string,
   streamStatus: PropTypes.string,
   onClickJoin: PropTypes.func,
   streamPrice: PropTypes.number,
   onClickUnlock: PropTypes.func,
   paymentButtonLoading: PropTypes.bool,
   isCustomPreview: PropTypes.bool,
   voiceIconRightPosition: PropTypes.number,
   children: PropTypes.any,
   streamState: PropTypes.string,
   isLockedForAllMemberships: PropTypes.bool,
   siteInfo: PropTypes.object,
   isHomepage: PropTypes.bool,
   isPlayPreview: PropTypes.bool,
   videoId: PropTypes.number,
   endsIn: PropTypes.any,
   isLockedForSFW: PropTypes.bool,
   cannotPreviewForSfw: PropTypes.bool,
   isAutoPlay: PropTypes.bool,
   screenWidth: PropTypes.number,
   setIsAutoPlay: PropTypes.func,
};

export default React.memo(VideoCardContent);
